import { RootState } from 'editor/src/store/index';

const isSidebarVisible = (state: RootState) => state.editorModules.sidebar.isVisible;

export default isSidebarVisible;
